import fetch from '@/api/fetch'

/** 查询企业列表 */
export const getEnterpriseList = params => fetch.get('/sys/org/list', { params });

/** 根据id查询企业 */
export const getEnterpriseById = id => fetch.get(`/sys/org/id/${id}`);

/** 根据id查询部门 */
export const getUnitById = id => fetch.get(`/sys/org/unit/id/${id}`);

/** 审核企业 */
export const enterpriseAudit = auditInfo => fetch.post('/sys/org/audit', auditInfo);

/** 根据id改变企业的启用禁用状态 */
export const updateEnterpriseEnabledById = (enabled, id) => fetch.post(`/sys/org/enabled/update/${id}/${enabled}`);


/** 根据id改变企业的有效日期 */
export const updateEnterpriseEffectiveById = org => fetch.post(`/sys/org/effective/update`, org);



/** 获取所有企业统计 */
export const getAllOrgStatistics = _ => fetch.get('/sys/org/statistics/all');

/** 获取按企业分开统计 */
export const getStatisticsByOrg = params => fetch.get('/sys/org/statistics/org', { params });

/** 获取按企业id获取统计信息 */
export const getStatisticsByOrgId = orgId => fetch.get(`/sys/org/statistics/org/id/${orgId}`);

/** 获取企业、部门、人员树 */
export const getOrgUnitUserTreeByOrgId = orgId => fetch.get(`/sys/org/unit/tree/id/${orgId}`)

/** 获取企业角色列表 */
export const getOrgRoleListByOrgId = orgId => fetch.get(`/sys/org/role/list/id/${orgId}`)

/** 获取企业项目/施工队/班组树 */
export const getOrgProjectTree = params => fetch.get('/sys/org/project/tree', { params });